import * as yup from 'yup';

// We're pushing separate validations as array entries to match each form step.
const personalizationValidationSchema = [];

// Pasted values routinely carry leading/trailing whitespace. Trim before any
// format or presence check runs, so " a@b.com " is treated as the address the
// user meant rather than rejected with no visible reason.
const trimmedString = () => yup.string().trim();

// Whitespace-only is empty for the purposes of the "did they fill anything in"
// checks below.
const isBlank = (value) => value === undefined || value === null || value.trim().length === 0;

// STEP 1 Validation: Account Lookup Step.
personalizationValidationSchema.push(
  yup.object().shape({
    first_name: trimmedString(),
    last_name: trimmedString(),
    email: trimmedString().when(['last_name', 'first_name'], {
      is: (lastName, firstName) => {
        let fieldsEmpty = false;

        if (isBlank(lastName) && isBlank(firstName)) {
          fieldsEmpty = true;
        }
        // Return true IF Last name & Email are both blank.
        return fieldsEmpty;
      },
      then: trimmedString().required(
        'Enter a first name and/or a last name and/or an email address.',
      ),
      otherwise: trimmedString().email('Make sure to type a valid email address'),
    }),
  }),
);

// STEP 2 Validation: Account selection step in a situation where multiple
// records are found. If "Create New" is not trigger, it is required.
personalizationValidationSchema.push(
  yup.object().shape({
    action: yup.string(),
    residentSelection: yup.string().when('action', {
      is: (action) => {
        const isNotCreateNew = action !== 'create new';
        return isNotCreateNew;
      },
      then: yup
        .string()
        .required(
          'Select one of the entries from the list above before clicking the CONTINUE button. If the person you are looking for is not listed, click the CREATE NEW link.',
        ),
      otherwise: yup.string(),
    }),
  }),
);

// STEP 3 Validation: User not found validation.
// There aren't any fields to validate, but this is needed to line up
// validation with form steps.
personalizationValidationSchema.push(yup.object().shape({}));

// STEP 4 Validation: Account selection step in a situation where multiple records are found.
personalizationValidationSchema.push(
  yup.object().shape(
    {
      email: trimmedString()
        .email('Make sure to type a valid email address')
        .required('Make sure to type a valid email address'),
      first_name: trimmedString().required('Enter a first name.'),
      last_name: trimmedString().required('Enter a last name.'),
      person2_first_name: trimmedString()
        .when('person2_email', {
          is: (value) => !isBlank(value),
          then: trimmedString().required('Enter a first name'),
          otherwise: trimmedString(),
        })
        .when('person2_last_name', {
          is: (value) => !isBlank(value),
          then: trimmedString().required('Enter a first name'),
          otherwise: trimmedString(),
        }),
      person2_last_name: trimmedString()
        .when('person2_email', {
          is: (value) => !isBlank(value),
          then: trimmedString().required('Enter a last name'),
          otherwise: trimmedString(),
        })
        .when('person2_first_name', {
          is: (value) => !isBlank(value),
          then: trimmedString().required('Enter a last name'),
          otherwise: trimmedString(),
        }),
      person2_email: trimmedString().email('Make sure to type a valid email address'),
    },
    ['person2_first_name', 'person2_last_name'],
  ),
);

export default personalizationValidationSchema;
